import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { SetAuthToken } from '../store/user/user.action';
import { Store } from '@ngxs/store';
import { Auth } from '@angular/fire/auth';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  urlsToNotUse: any = [];
  app: any;
  constructor(private authServices: AuthService, private store: Store) {
    this.urlsToNotUse = ['auth/.+'];
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.app = initializeApp(environment.firebaseConfig);
    const authToken = this.authServices.userInfo.authToken;

    const requestUrl = request.urlWithParams;
    const isToritoApiRequest = requestUrl.includes(environment.toritoApiURl);

    if (this.authServices.isLoggedIn && !isToritoApiRequest)
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`,
        },
      });

    // return next.handle(request);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return from(this.getCurrentIdToken()).pipe(
            switchMap((newToken: any) => {
              this.store.dispatch(new SetAuthToken(newToken));

              const clonedRequest = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`,
                },
              });

              return next.handle(clonedRequest);
            }),
            catchError((err) => {
              return throwError(() => err);
            })
          );
        }
        return throwError(() => error);
      })
    );
  }

  getCurrentIdToken() {
    return new Promise((resolve, reject) => {
      const auth = getAuth(this.app);
      const unsubscribe = auth.onIdTokenChanged((user) => {
        unsubscribe();
        if (user) {
          user.getIdToken().then((token) => {
            resolve(token);
          });
        } else {
          reject(null);
        }
      }, reject);
    });
  }
}

// export class AuthInterceptor implements HttpInterceptor {
//   // private auth= inject(AuthService);
//   private auth = inject(Auth);
//   // private store = inject(Store);

//   // intercept(
//   //   request: HttpRequest<any>,
//   //   next: HttpHandler
//   // ): Observable<HttpEvent<any>> {
//   //   const requestUrl = request.urlWithParams;
//   //   const isToritoApiRequest = requestUrl.includes(environment.toritoApiURl);

//   //   const token = this.authService.userInfo.authToken;
//   //   const isLoggedIn = this.authService.isLoggedIn;

//   //   if (isLoggedIn && !isToritoApiRequest) {
//   //     request = request.clone({
//   //       setHeaders: {
//   //         Authorization: `Bearer ${token}`,
//   //       },
//   //     });
//   //   }

//   //   return next.handle(request).pipe(
//   //     catchError((error: HttpErrorResponse) => {
//   //       if (error.status === 401) {
//   //         return from(this.getNewFirebaseToken()).pipe(
//   //           switchMap((newToken: string) => {
//   //             this.store.dispatch(new SetAuthToken(newToken));
//   //             const clonedRequest = request.clone({
//   //               setHeaders: {
//   //                 Authorization: `Bearer ${newToken}`,
//   //               },
//   //             });
//   //             return next.handle(clonedRequest);
//   //           }),
//   //           catchError((err) => throwError(() => err))
//   //         );
//   //       }
//   //       return throwError(() => error);
//   //     })
//   //   );
//   // }

//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     const skipAuth = req.headers.has('No-Auth');

//     if (skipAuth) {
//       const cleanHeaders = req.headers.delete('No-Auth');
//       const cleanReq = req.clone({ headers: cleanHeaders });
//       return next.handle(cleanReq);
//     }

//     return from(
//       this.auth.currentUser?.getIdToken() ?? Promise.resolve('')
//     ).pipe(
//       switchMap((token: string) => {
//         const authReq = req.clone({
//           setHeaders: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         return next.handle(authReq).pipe(
//           catchError((error: HttpErrorResponse) => {
//             if (error.status === 401) {
//               console.warn(
//                 'Token expirado o inválido. Debes cerrar sesión o reintentar.'
//               );
//               // Aquí puedes disparar logout, mostrar error, etc.
//             }
//             return throwError(() => error);
//           })
//         );
//       })
//     );
//   }

//   private getNewFirebaseToken(): Promise<string> {
//     const auth = getAuth();
//     return new Promise((resolve, reject) => {
//       const unsubscribe = auth.onIdTokenChanged((user) => {
//         unsubscribe(); // limpiamos el listener
//         if (user) {
//           user.getIdToken(true).then(resolve).catch(reject);
//         } else {
//           reject('No authenticated user');
//         }
//       }, reject);
//     });
//   }
// }
